import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderOptionLegView,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import TransparentSelectField from '#/components/UnifiedRfqs/components/TransparentSelectField';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  FormOption,
  OptionKind,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/types';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function InstrumentSelector() {
  const view = useRfqBuilderOptionLegView();
  const { selectOptionLegInstrument } = useRfqBuilderActions();

  const { instrumentKind, index } = view;
  const isMobile = useIsMobile();
  const { strategy, strategyShortcut } = useRfqBuilderView();
  const trackAction = useTrackAction();

  const strategyCode =
    strategyShortcut.selectedOption?.value ??
    strategy.selectedOption?.value ??
    null;

  const handleOnChange = useCallback(
    (option: FormOption<OptionKind> | null) => {
      trackAction('update strategy leg', {
        strategyCode,
        kind: option?.value ?? null,
        isHedge: view.isHedge,
      });

      if (option != null) selectOptionLegInstrument(index, option.value);
    },
    [index, selectOptionLegInstrument, strategyCode, trackAction, view.isHedge],
  );

  return useMemo(
    () => (
      <TransparentSelectField
        aria-label="Select instrument"
        isDisabled={instrumentKind.isDisabled}
        noOpacity
        options={instrumentKind.options}
        value={instrumentKind.selectedOption}
        onChange={handleOnChange}
        isSearchable={!isMobile}
      />
    ),
    [
      instrumentKind.isDisabled,
      instrumentKind.options,
      instrumentKind.selectedOption,
      handleOnChange,
      isMobile,
    ],
  );
}
